export default "__VITE_ASSET__b789be86__"